<footer class="app-footer">
  <span class="footer-brand">Nyzed</span>
  <div class="footer-links">
    <a href="mailto:wedo@itscocchi.it">wedo&#64;itscocchi.it</a>
    <span class="footer-sep">·</span>
    <a routerLink="/cookie-policy">Cookie Policy</a>
    <span class="footer-sep">·</span>
    <a routerLink="/privacy-policy">Privacy Policy</a>
  </div>
  <span class="footer-copy">© 2026 itscocchi.it</span>
</footer>
